<div class="modal-table-container">
  <table mat-table matSort  [dataSource]="dataSource" (matSortChange)="sortData($event)"
         class="table gs-0 gy-3"
         multiTemplateDataRows>
    <ng-container matColumnDef="name" sticky>
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let directorship">
      <span class="fw-bold" role="button" (click)="openDirectorProfile(directorship)">
        {{[directorship.director.firstname,directorship.director.middlenames,directorship.director.lastname] | joinArray}}
      </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="age">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by age">
        <div class="d-flex flex-row align-items-center">
          Age
          <i class="bi bi-question-circle ps-1" [matTooltip]="methodology.director_age" #tt_director_age="matTooltip" (click)="tt_director_age.toggle()"></i>
        </div>
      </th>
      <td mat-cell *matCellDef="let directorship">
        <span>{{directorship.director.age | number}}</span>
      </td></ng-container
    >

    <ng-container matColumnDef="gender">
      <th mat-header-cell *matHeaderCellDef>
        <div class="d-flex flex-row align-items-center">
          Gender
          <i class="bi bi-question-circle ps-1" [matTooltip]="methodology.director_gender" #tt_director_gender="matTooltip" (click)="tt_director_gender.toggle()"></i>
        </div>
      </th>
      <td mat-cell *matCellDef="let directorship">
        <span>{{directorship.director.gender | titlecase}}</span>
      </td></ng-container
    >

    <ng-container *ngIf="subscription || !company.is_premium else blurred">
      <ng-container matColumnDef="influence">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Influence">
          <div class="d-flex flex-row align-items-center">
            Influence
            <i class="bi bi-question-circle ps-1" [matTooltip]="methodology.director_influence" #tt_director_influence="matTooltip" (click)="tt_director_influence.toggle()"></i>
          </div></th>
        <td mat-cell *matCellDef="let directorship">
          <span>{{directorship.influence / 100 | percent}}</span>
        </td></ng-container
      >
      <ng-container matColumnDef="overall">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by overall">Overall</th>
        <td mat-cell *matCellDef="let directorship">
          <span>{{directorship.overall | number : '1.3-3'}}</span>
        </td
        ></ng-container>

      <ng-container matColumnDef="ebitda">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by EBITDA">EBITDA</th>
        <td mat-cell *matCellDef="let directorship">
          <span>{{directorship.ebitda | number : '1.3-3'}}</span>
        </td
        ></ng-container>

      <ng-container matColumnDef="carbon_intensity">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Carbon Intensity">Carbon Intensity</th>
        <td mat-cell *matCellDef="let directorship">
          <span>{{directorship.carbon_intensity | number : '1.3-3'}}</span>
        </td
        ></ng-container>

      <ng-container matColumnDef="tsr">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by TSR">TSR</th>
        <td mat-cell *matCellDef="let directorship">
          <span>{{directorship.tsr | number : '1.3-3'}}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="controversies">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Controversies">Controversies</th>
        <td mat-cell *matCellDef="let directorship">
          <span>{{directorship.controversies | number : '1.3-3'}}</span>
        </td
        ></ng-container>
    </ng-container>


    <ng-template #blurred>

      <ng-container matColumnDef="influence">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Influence">Influence</th>
        <td mat-cell *matCellDef="let directorship" class="blurred">
          <span>{{0 | percent}}</span>
        </td></ng-container
      >
      <ng-container matColumnDef="overall">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by overall">Overall</th>
        <td mat-cell *matCellDef="let directorship" class="blurred">
          <span>{{0 | number : '1.3-3'}}</span>
        </td
        ></ng-container>

      <ng-container matColumnDef="ebitda">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by EBITDA">EBITDA</th>
        <td mat-cell *matCellDef="let directorship" class="blurred">
          <span>{{0 | number : '1.3-3'}}</span>
        </td
        ></ng-container>

      <ng-container matColumnDef="carbon_intensity">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Carbon Intensity">Carbon Intensity</th>
        <td mat-cell *matCellDef="let directorship" class="blurred">
          <span>{{0 | number : '1.3-3'}}</span>
        </td
        ></ng-container>

      <ng-container matColumnDef="tsr">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by TSR">TSR</th>
        <td mat-cell *matCellDef="let directorship" class="blurred">
          <span>{{0 | number : '1.3-3'}}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="controversies">
        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Controversies">Controversies</th>
        <td mat-cell *matCellDef="let directorship" class="blurred">
          <span>{{0 | number : '1.3-3'}}</span>
        </td
        ></ng-container>
    </ng-template>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let directorship; columns: displayedColumns"
      class="element-row"
    ></tr>
  </table>
</div>
